import {
  Directive,
  forwardRef,
  Input,
  ElementRef,
  HostListener,
  Renderer2,
  OnDestroy
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuestionBase } from 'app/core/components/forms';

@Directive({
  selector: '[skeletorValueAccessor]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SkeletorValueAccessor),
      multi: true
    }
  ]
})
export class SkeletorValueAccessor implements ControlValueAccessor, OnDestroy {
  onChange: any = () => {};
  onTouched: any = () => {};

  private question: QuestionBase<any>;
  private listeners = [];
  private _value: any;
  private _validateOnEdit = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    // console.log('SkeletorValueAccessor constructor');
    // console.log(this.elementRef);
    // console.log(this.ngControl);
    // console.log(this.elementRef.nativeElement.tagName);
  }

  @Input() set validateOnEdit(flag: string) {
    this._validateOnEdit = !!(flag && flag.toLowerCase() === 'true');
  }

  @Input() set skeletorValueAccessor(question: QuestionBase<any>) {
    this.question = question ? question : new QuestionBase();
    this._value = this.question.parseValue(this.question.value);
    if (
      this.question &&
      this.question.key &&
      this.question.controlType !== 'group' &&
      this.question.eventHandlers
    ) {
      const component = this.elementRef.nativeElement;
      if (component) {
        this.listeners = Object.keys(this.question.eventHandlers).map((eventHandler) => {
          return this.renderer.listen(
            component,
            eventHandler,
            ((event) => {
              this.question.eventHandlers[eventHandler](event.detail.value, this.question);
            }).bind(this)
          );
        });
      }
    }
  }

  @HostListener('onChange', ['$event.detail.value'])
  listenForValueChange(value): void {
    // console.log('onChange ', this.question.label, value, this.question);
    this.value = this.question.parseValue(value);
  }

  @HostListener('onKeyup', ['$event.detail.value'])
  listenForKeyup(value): void {
    if (this._validateOnEdit) {
      this.value = this.question.parseValue(value);
    }
  }

  get value(): any {
    // console.log('get value ', this.question.label);
    return this._value;
  }

  set value(val) {
    if (!this.equals(val, this._value)) {
      // console.log('set value ', this.question.label, val, this._value);
      this._value = val;
      // this.question.value = this.question.parseValue(this._value);
      this.onChange(this._value);
      this.onTouched();
    }
  }

  /**
   * Check if values are equal, null and undefined are considered as empty string
   * @param a
   * @param b
   */
  equals(a, b): boolean {
    // eslint-disable-next-line
    return (
      JSON.stringify(a == null ? '' : a).localeCompare(JSON.stringify(b == null ? '' : b)) === 0
    );
  }

  writeValue(value: string): void {
    // console.log('write value', this.question.label, value);
    this.value = value;
    this.question.value = value; //this.question.parseValue(value);
    // this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    // this.question.onDeleteQuestion();
    this.clearListeners();
  }

  clearListeners(): void {
    this.listeners.forEach((listener) => listener());
  }
}
